// Index
// 1. Event Listeners
// 2. Functions


// Event Listeners
// 1. Event listener for 'DOMContentLoaded' - Executes code when the DOM content is loaded.
// 2. Event listener for 'keydown' - Listens for keydown events, particularly the ESC key.
// 3. Event listener for 'touchstart' - Listens for touchstart events on mobile devices.
// 4. Event listener for 'touchmove' - Listens for touchmove events on mobile devices.
// 5. Event listener for  'customizer.scene-rendered' - Listens for customizer.scene-rendered when the 3D scene is completely rendered.
// 6. Event listener for  'customizer.recipe-changed' Triggered when there's a change in the customization recipe.
// Add more event listeners if needed...


// Functions
// 1.  lockBody() - Locks the body scroll when the side vu customizer popup is open.
// 2.  unlockBody() - Unlocks the body scroll when the side vu customizer closes.
// 3.  openModal() - Opens the main modal.
// 4.  openLoadingModal() - Displays the loading modal.
// 5.  openAdditionalModal() - Opens an additional modal (warning message) before closing the main modal.
// 6.  closeSubModal() - Closes the additional modals.
// 7.  closeBothModal() - Closes both the additional modals and the main modal.
// 8.  closeModal() - Closes the main modal and opens the additional modal if needed.
// 9.  popUpConfirmationModal() - Opens a confirmation modal before resetting the customizer.
// 10. popUpConfirmationModalCheck() - Checks if a confirmation modal needs to be opened before resetting the customizer.
// 11. getActiveTabIndex() - Updates the active tab index and adjusts UI elements accordingly.
// 12. addDefaultOption(selectId, defaultText) - Adds a default option to select elements.
// 13. handleAddToCartState() - Handles loading state and error for Add to Cart button.
// Add more functions if needed...



const updateActiveTabClass = () => {
    // Remove 'active' class from all tabs
    document.querySelectorAll('#customizer-tab-container .nav-link').forEach(tab => {
        tab.classList.remove('active');
    });
    const current = customizer.tabs.current();
    const totalTab = customizer.tabs.count();
    let vuNext = document.getElementById("tab-next");
    let vuPrev = document.getElementById("vu-previous");




    if (current === totalTab) {
        // Hide the next button which is currently disabled
        vuNext.classList.add('hidden-important');
        // Show the "customizer-add-to-cart-button"
        document.getElementById('customizer-add-to-cart-button').style.display = 'block';


    } else {
        vuNext.classList.remove('hidden-important');
        document.getElementById('customizer-add-to-cart-button').style.display = 'none';
    }
    // Add 'active' class to the currently selected tab

    if (current) {
        const activeTab = document.querySelector('#customizer-tab-container .customizer-tab-selected');
        if (activeTab) {
            activeTab.classList.add('active');
        }
    }
};

// Define the trap function
function isScreenSizeAbove750px() {
    // Get the screen width
    const screenWidth = window.innerWidth;
    return screenWidth > 750;
}
function trap(element) {
}

// Function to find all focusable elements within a container
function getFocusableElements(container) {
    // Define a selector for all focusable elements
    const focusableSelectors = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])',
        '[contenteditable="true"]'
    ];

    // Join the selectors into a single string and find matching elements
    return container.querySelectorAll(focusableSelectors.join(', '));
}

// Function to find the selected tab and call the trap function
function callTrapOnSelectedTab() {
    // Select the element with the class 'customizer-tab-body:not(.customizer-hidden)'
    const selectedTab = document.querySelector('.customizer-tab-body:not(.customizer-hidden)');


    if (isScreenSizeAbove750px()) {
        // Check if the element exists before attempting to call the trap function
        if (selectedTab) {
            trap(selectedTab);

            // Find all focusable elements within the selected tab
            const focusableElements = getFocusableElements(selectedTab);

            // Check if there are any focusable elements and set focus on the first one
            if (focusableElements.length > 0) {
                focusableElements[0].focus();
            }
        }
    }
}


// Example usage: call this function whenever you need to trigger the trap


const updateNextButtonState = () => {
    const nextTabButton = document.getElementById("tab-next");
    const prevTabButton = document.getElementById("vu-previous");
    const currentTab = customizer.tabs.current();
    if (currentTab && currentTab.valid) {
        nextTabButton.removeAttribute('disabled');
        nextTabButton.classList.remove('disabled');
    } else {
        nextTabButton.setAttribute('disabled', 'disabled');
        nextTabButton.classList.add('disabled');
    }
    buttonCheck();
    // on fit step checking if we have selected option enable the next button
};
const buttonCheck = () => {
    const activeTab = document.querySelector('#customizer-tab-container .customizer-tab-selected');
    const listItems = document.querySelectorAll(".customizer-list-element-item-selected");
    const nextTabButton = document.getElementById("tab-next");
    if (activeTab.getAttribute('id') == 'customizer-tab-fitting') {
        listItems.forEach((item) => {
            nextTabButton.removeAttribute('disabled');
            nextTabButton.classList.remove('disabled');
        });
    }
};
function scrollToTop(elementId) {
    var element = document.getElementById(elementId);
    if (element) {
        element.scrollTop = 0;
    }
}
const initTabData = () => {

    let nextTabButton = document.getElementById('tab-next');
    let prevTabButton = document.getElementById('vu-previous');

    customizer.tabs.selectFirstVisible();

    let currentTabIndex = document.getElementById('active_number');
    let tabCount = document.getElementById('total_number');
    currentTabIndex.innerHTML = customizer.tabs.currentIndex();
    tabCount.innerHTML = customizer.tabs.count();

    updateNextButtonState();

    nextTabButton.addEventListener('click', () => {
        this.customizer.tabs.next();
        updateActiveTabClass();
        scrollToTop("right-side");
        callTrapOnSelectedTab();
    });

    prevTabButton.addEventListener('click', () => {
        this.customizer.tabs.previous();
        updateActiveTabClass();
        scrollToTop("right-side");
        callTrapOnSelectedTab();
    });
    // Optionally, handle keyboard navigation (up/down arrow keys) for accessibility:
    document.addEventListener('keydown', (event) => {
        // Check if all divs with class .modal-check are hidden
        const additionalModals = document.querySelectorAll('.modal-check');
        const allHidden = Array.from(additionalModals).every(modal => {
            const style = window.getComputedStyle(modal);
            return style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0';
        });

        if (allHidden) {
            if (event.key === 'ArrowLeft') {
                prevTabButton.click();
            } else if (event.key === 'ArrowRight') {
                nextTabButton.click();
            }
        }
    });

};
const initTabChangeEventListener = () => {
    document.addEventListener('customizer.tab-selected', (event) => {
        let currentTabIndex = document.getElementById('active_number');
        let tabCount = document.getElementById('total_number');
        currentTabIndex.innerHTML = customizer.tabs.currentIndex();
        tabCount.innerHTML = customizer.tabs.count();

        updateActiveTabClass();
        updateNextButtonState();
    });
};

const setupEventListeners = () => {
    document.addEventListener("customizer.action-click", function (event) {
        handleActionClick(event);
    });

    document.addEventListener("customizer.action-hover", function (event) {
        handleActionHover(event);
    });
};

const handleActionClick = (event) => {
    if (event?.detail) {
        const code = event.detail.element;
        switch (code) {
            case 'reset-sizes':
                customizer.resetElementGroup('size_size');
                customizer.elements.size_right.disable();
                break;
            default:
                break;
        }
        if (customizer.debug) {
            console.log('customizer.action-click event fired', event);
        }
    }
};

const handleActionHover = (event) => {
    if (demoLayout && event?.detail?.id === 'hover_id') {
        const { isHovering } = event.detail;
        Object.assign(demoLayout.style, {
            width: isHovering ? size : 'auto',
            height: isHovering ? size : 'auto',
            backgroundColor: isHovering ? demoBgColor.b : 'transparent'
        });
        if (customizer.debug) {
            console.log("customizer.action-hover event fired", event);
        }
    }
};
document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('customizer.scene-rendered', () => {
        // initPriceChangeEventListener();
        // initResetRecipe();
        initTabData();
        initTabChangeEventListener();
        // initShowToastOnCartToAddClicked();
        // applyBootstrapTabsClasses();
        setupEventListeners();
        // initPrintSummaryHandler();
        document.addEventListener("customizer.recipe-updates-complete", handleRecipeUpdatesComplete);
        
        // Initialize Add to Cart button handling
        handleAddToCartState();
    });
});

function handleRecipeUpdatesComplete(event) {
    const recipe = event?.detail?.recipe;
    const elementMapping = {
        'fit': 'fitting_info',
        'tongue_model': 'tongue_info',
        'color': 'color_info',
        // 'blade_fit': 'blade_fit_info',
        // 'holder_fit': 'holder_fit_info'
    };

    Object.entries(recipe).forEach(([elementCode, elementData]) => {
        const targetElementKey = elementMapping[elementCode];

        if (targetElementKey) {
            const targetElement = customizer.elements[targetElementKey];

            if (targetElement) {
                targetElement.show();

                targetElement.hideAllOptions();

                targetElement.toggleOptionVisibility(elementData.value.code, true);
            }
        }
    });

    updateNextButtonState();
}





// JTB Custom Code Start Here //
document.addEventListener("DOMContentLoaded", function () {


    let sceneRenderedFlag = false;
    // function locks the body when side vu customizer popup
    function lockBody() {
        var lastTop = window.scrollY;
        var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        document.body.classList.add('locked');
    }

    // function unlocks the body when side vu customizer closes
    function unlockBody() {
        var lastTop = Math.abs(parseInt(document.body.style.top));
        var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        document.body.classList.remove('locked');
    }

    // customizer.resetPerspective()



    // Selectors
    const modal = document.getElementById('vu_modal');
    const openModalButton = document.querySelectorAll('[name="showmodal"]');
    const noteModal = document.getElementById('note-modal');
    const noteModalShare = document.getElementById('note-modal-share');
    const warningModal = document.getElementById('warning-modal');
    const modalCloseButton = document.querySelector('.close');
    const loadingCloseButton = document.querySelector('.close-loading');
    const subModalCloseButton = document.querySelectorAll('.sub-modal');
    const subModalShareCloseButton = document.querySelectorAll('.sub-modal-share-close');
    const saveCloseButton = document.querySelector('.save-close');
    const loadingContainer = document.querySelector('.loading-vu-modal');
    const confirmResetButton = document.getElementById("confirmReset");
    const qrModal = document.getElementById("qr-modal");
    const additionalModalExit = document.getElementById("additional-modal-exit-popup");
    const shareButton = document.getElementById("shareButton");
    let addtional_text = document.getElementById("addtional-text");




    // Event listeners
    openModalButton.forEach(button => {
        button.addEventListener('click', openPopUpModal);
    });

    if (additionalModalExit) {
        additionalModalExit.addEventListener('click', closeBothModal);
    }

    if (modalCloseButton) {
        modalCloseButton.addEventListener('click', closeModal);
    }
    if (shareButton) {
        shareButton.addEventListener('click', shareModalPopup);
    }

    if (subModalCloseButton) {
        subModalCloseButton.forEach(button => {
            button.addEventListener('click', closeSubModal);
        });
    }
    if (subModalShareCloseButton) {
        subModalShareCloseButton.forEach(button => {
            button.addEventListener('click', closeSubModal);
        });
    }

    if (loadingCloseButton) {
        loadingCloseButton.addEventListener('click', loadingModalClose);
    }


    document.addEventListener('keydown', function (event) {
        // Check if the pressed key is ESC (key code 27)
        if (event.keyCode === 27) {
            if (noteModal.style.display !== 'none' || noteModalShare.style.display !== 'none' || warningModal.style.display !== 'none' || qrModal.style.display !== 'none') {
                // Call the close function of the active modal 
                closeSubModal();
            } else {
                closeModal();
            }
        }
    });


    // Functions
    function QrFocusTrap() {
        const modal = qrModal;
        const focusableElements = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];

        // Function to handle keyboard navigation
        function trapFocus(e) {
            if (e.key === 'Tab') {
                if (e.shiftKey) { // If Shift + Tab is pressed
                    if (document.activeElement === firstFocusableElement) {
                        e.preventDefault();
                        lastFocusableElement.focus();
                    }
                } else { // Just Tab is pressed
                    if (document.activeElement === lastFocusableElement) {
                        e.preventDefault();
                        firstFocusableElement.focus();
                    }
                }
            }
        }

        // Add event listener to handle keyboard navigation
        modal.addEventListener('keydown', trapFocus);

        // Ensure the focus is initially set inside the modal
        firstFocusableElement.focus();
    }

    function openQrModal() {
        qrModal.style.display = 'block';
        QrFocusTrap();
        document.getElementById('close-button-qr').focus();
    }
    function loadingModalClose() {
        loadingContainer.style.display = 'none';
        unlockBody();
    }
    function openModal() {
        loadingContainer.style.display = 'none';
        modal.style.display = 'block';
        window.dispatchEvent(new Event('resize'));
        lockBody();
    }
    // splash loading screen
    function openLoadingModal() {
        loadingContainer.style.display = 'block';
        lockBody();
    }
    // funtion to popup warning message before closing the modal
    function openAdditionalModal() {
        // Display the noteModal
        noteModal.style.display = 'block';
        showProgressText();
    }


    function closeSubModal() {
        noteModalShare.style.display = 'none';
        noteModal.style.display = 'none';
        warningModal.style.display = 'none';
        qrModal.style.display = 'none';
    }

    function closeBothModal() {
        noteModal.style.display = 'none';
        modal.style.display = 'none';
        unlockBody();
        customizer.reset();
        var progressBarInner = document.getElementById('progress-bar-inner');
        progressBarInner.style.width = '50px';
        showProgressText();
    }

    function closeModal() {
        const additionalModalNeeded = customizer.recipeChanged;
        additionalModalNeeded ? openAdditionalModal() : (modal.style.display = 'none');
        unlockBody();
    }
    function shareModalPopup() {
        noteModalShare.style.display = 'block';
        showProgressText();
    }
    function resetSizes() {
        customizer.resetElementGroup('size_size');
        const selectColor = document.querySelectorAll("#customizer-root select");
        selectColor.forEach(select => {
            select.style.color = "#B3B3B3";
        });
    }
    function resetView() {
        customizer.resetPerspective();
    }



    // Check if the URL contains 'recipe_id'
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('recipe_id')) {
        openPopUpModal();
    }
    let startY;

    function handleTouchStart(event) {
        if (event.target.id === "mobile-close") {
            startY = event.touches[0].clientY;
        }
    }

    function handleTouchMove(event) {
        if (startY !== undefined && event.changedTouches.length > 0) {
            let deltaY = event.changedTouches[0].clientY - startY;
            if (deltaY < -50) { // Arbitrary threshold for swipe up
                closeModal();
                startY = undefined; // Reset startY after closing modal
            }
        }
    }

    document.addEventListener("touchstart", handleTouchStart);
    document.addEventListener("touchmove", handleTouchMove);






    // Listen for the customizer.models-loaded event
    document.addEventListener('customizer.scene-rendered', function () {

        let resetSizeButton = document.getElementById("customizer-element-sizes-reset-action");
        let runnerSharpening = document.getElementById("customizer-element-runner_sharpening");
        if (resetSizeButton) {
            resetSizeButton.setAttribute('tabindex', '0');
        }
        var elements = document.querySelectorAll('.customizer-list-element-html-item');

        // Loop through each element and set the tabindex attribute to 0
        elements.forEach(function (element) {
            element.addEventListener('keydown', function (event) {
                // Check if the space key (key code 32) is pressed
                if (event.code === 'Space') {
                    // Prevent the default action to avoid scrolling
                    event.preventDefault();
                    // Toggle the 'selected' class on the element
                    element.classList.toggle('selected');
                }
            });
        });

        function cloneAdditionalText() {
            // Find the additional_text element
            let additionalText = document.getElementById("addtional-text");
            // Find the runnerSharpening element
            let runnerSharpening = document.getElementById("customizer-element-runner_sharpening");
            // Check if both elements exist
            if (additionalText && runnerSharpening) {
                // Clone the additional_text element
                let clonedElement = additionalText.cloneNode(true);
                // Append the cloned element to runnerSharpening
                runnerSharpening.appendChild(clonedElement);
            }
        }
        cloneAdditionalText();
        // Check if the URL contains the 'recipe_id' or 'variant' parameter
        if (window.location.search.includes('recipe_id') || window.location.search.includes('variant')) {
            // Add a 5-second delay before executing the URL modification
            setTimeout(function () {
                // Create a new URL object based on the current URL
                var url = new URL(window.location.href);
                // Get the search string
                var searchString = url.search;

                // Find the index of 'recipe_id' or 'variant', whichever comes first
                var recipeIdIndex = searchString.indexOf('recipe_id');
                var variantIndex = searchString.indexOf('variant');

                // Determine the earliest index to truncate the search string
                var truncateIndex = -1;
                if (recipeIdIndex !== -1 && variantIndex !== -1) {
                    truncateIndex = Math.min(recipeIdIndex, variantIndex);
                } else if (recipeIdIndex !== -1) {
                    truncateIndex = recipeIdIndex;
                } else if (variantIndex !== -1) {
                    truncateIndex = variantIndex;
                }

                // Truncate the search string if a valid index is found
                if (truncateIndex !== -1) {
                    var newSearch = searchString.substring(0, truncateIndex - 1); // Remove preceding '&' or '?'
                    url.search = newSearch;
                }

                // Update the browser's address bar without reloading the page
                window.history.replaceState({}, document.title, url.toString());
            }, 5000); // 5000 milliseconds = 5 seconds
        }

        // Set sceneRenderedFlag to true when the event is triggered.
        sceneRenderedFlag = true;

        let subModalCloseButton = document.querySelectorAll('.close-sub-modal');
        let restartButton = document.getElementById("customizer-restart-button");
        let resetButton = document.getElementById("customizer-reset-view");

        if (restartButton) {
            restartButton.addEventListener('click', popUpConfirmationModalCheck);
        }
        if (resetButton) {
            resetButton.addEventListener('click', resetView);
        }
        document.addEventListener("customizer.recipe-updates-complete", handleRecipeUpdatesComplete);

        const qrButton = document.getElementById("customizer-element-size_find_your_size");
        if (qrButton) {
            qrButton.addEventListener('click', openQrModal);
        }


        function addTabIndexToClasses(classList) {
            // Loop through each class in the list
            classList.forEach(function (className) {
                // Select all elements with the current class
                var elements = document.querySelectorAll('.' + className);

                // Loop through each element and add the tabindex attribute with the value 0
                elements.forEach(function (element) {
                    element.setAttribute('tabindex', '0');
                });
            });
        }

        // Call the function with an array of classes
        addTabIndexToClasses(['customizer-list-element-select', 'customizer-list-element-swatch-item']);



        // Grab the base price of the product from the product detail page
        var productPriceElement = document.querySelector('.customizer-price-hidden');
        var basePrice = 0;

        // Check if productPriceElement exists before accessing its attribute
        if (productPriceElement) {
            var priceText = productPriceElement.getAttribute('data-product-price');
            // Ensure priceText is not null before attempting to replace characters
            if (priceText) {
                basePrice = parseFloat(priceText) / 100;
            }
        }
        // Call the customizer.setBasePrice() method with the base price
        if (window.Shopify.currency.active === 'CAD') {
            customizer.currency = "USD";
        } else {
            customizer.currency = window.Shopify.currency.active;
        }
        customizer.setBasePrice(basePrice);

         // ===== BEGIN: PRICE FORMAT CUSTOMIZATION - REMOVE "US" SUFFIX =====
         const priceElement = document.querySelector('.customizer-price');
            
         if (priceElement) {
             // Efficient function to remove "US" from price displays
             const removeUS = () => {
                 // Target both main price and summary price elements
                 document.querySelectorAll('.customizer-price, .customizer-element-summary-total-price-value')
                     .forEach(el => {
                         if (el?.innerHTML?.includes('US')) {
                             el.innerHTML = el.innerHTML.replace(/(&nbsp;\$&nbsp;)US/, '$1');
                         }
                     });
             };
             
             // Run immediately and on recipe updates
             removeUS();
             document.addEventListener('customizer.recipe-updates-complete', removeUS);
             
             // Set up mutation observer for dynamic changes
             const observer = new MutationObserver(removeUS);
             
             // Observe both price elements
             ['.customizer-price', '.customizer-element-summary-total-price-value']
                 .forEach(selector => {
                     const element = document.querySelector(selector);
                     if (element) {
                         observer.observe(element, { 
                             childList: true, 
                             characterData: true, 
                             subtree: true,
                             attributes: true 
                         });
                     }
                 });
         }
         // ===== END: PRICE FORMAT CUSTOMIZATION - REMOVE "US" SUFFIX ===== 


        function popUpConfirmationModal() {
            warningModal.style.display = 'block';
            warningModal.focus();

            function closeSubModal() {
                warningModal.style.display = 'none';
            }

            function confirmReset() {
                customizer.reset();
                getActiveTabIndex();
                warningModal.style.display = 'none';
                var progressBarInner = document.getElementById('progress-bar-inner');
                progressBarInner.style.width = '50px';
            }

            document.getElementById('confirmReset').addEventListener('click', confirmReset);
            // Fix: Iterate through NodeList to add event listeners
            document.querySelectorAll('.close-sub-modal').forEach(button => {
                button.addEventListener('click', closeSubModal);
            });
        }



        //Check for recipe change if true open the warning message popup
        function popUpConfirmationModalCheck() {
            if (customizer.recipeChanged) {
                popUpConfirmationModal();
            }
            else {
                customizer.reset(); // Reset immediately if no changes
                getActiveTabIndex();
            }
        }



        // // Vu customizer current vs total number functionality, it include the enable/disable arrow buttons and ATC appears only in last tab
        let vuPrevious = document.getElementById("vu-previous");
        let vuNext = document.getElementById("tab-next");

        function getActiveTabIndex() {
            var activeTab = customizer.tabs.currentIndex();
            var tabCount = customizer.tabs.count();
            var progressWidth = (100 / tabCount) * (activeTab); // Account for 0-based index

            // element with id 'progress-bar-inner' for the progress bar
            var progressBarInner = document.getElementById('progress-bar-inner');
            progressBarInner.style.width = progressWidth + '%';

            // document.getElementById('active_number').innerHTML = customizer.tabs.currentIndex();
            // vuPrevious.classList.remove('disabled'); // Remove class before checking
            // vuNext.classList.remove('disabled'); // Remove class before checking
            // vuPrevious.classList.toggle('disabled', activeTab === 1);
            // vuNext.classList.toggle('disabled', activeTab === tabCount);


            if (activeTab === tabCount) {
                // Hide the next button which is currently disabled
                vuNext.classList.add('hidden-important');
                // Show the "customizer-add-to-cart-button"
                document.getElementById('customizer-add-to-cart-button').style.display = 'block';


            } else {
                vuNext.classList.remove('hidden-important');
                document.getElementById('customizer-add-to-cart-button').style.display = 'none';

            }
        }

        // document.getElementById('total_number').innerHTML = customizer.tabs.count();
        getActiveTabIndex();


        // Function to add default option to select element
        function addDefaultOption(selectId, defaultText) {
            var selectElement = document.getElementById(selectId);

            var defaultOption = document.createElement('option');
            defaultOption.text = defaultText;
            defaultOption.disabled = true;
            defaultOption.selected = true;
            defaultOption.style.color = 'grey'; // Set initial color to grey



            selectElement.insertBefore(defaultOption, selectElement.firstChild);

            selectElement.addEventListener('change', function () {
                if (this.value === defaultText) {
                    this.style.color = 'grey'; // Set color to grey if default option is selected
                } else {
                    this.style.color = 'black'; // Set color to black if another option is selected
                }
            });
        }

        // // Call the function for both select elements with their respective default texts
        // addDefaultOption('list-element-select-size_left', 'Select Left Foot Size...');
        // addDefaultOption('list-element-select-size_right', 'Select Right Foot Size...');


        // Select the input field for player number and set its placeholder text
        var playerNumberInput = document.querySelector('#customizer-element-tongue_personalization_number input');
        if (playerNumberInput) {
            playerNumberInput.placeholder = 'Add your player number...';
        }

        // Select the input field for player name and set its placeholder text
        var playerNameInput = document.querySelector('#customizer-element-tongue_personalization_name input');
        if (playerNameInput) {
            playerNameInput.placeholder = 'Add your player name...';
        }


        // // VU Tab next/previous function

        vuPrevious.addEventListener("click", function () {
            getActiveTabIndex();
        });

        vuNext.addEventListener("click", function () {
            getActiveTabIndex();

        });



        // For ADA purpose
        document.querySelector(".customizer-product-name").focus();

        // <-- Mobile screen resize feature Start Here -->

        let isResizing = false;
        let lastDownY = 0;

        let topDiv = document.getElementById('customizer-main-perspective');
        let bottomDiv = document.getElementById('right-side');
        let handle = document.getElementById('resizable-handle');


        handle.addEventListener('mousedown', startResize);
        handle.addEventListener('touchstart', startResize);

        function startResize(e) {
            topDiv_updated = topDiv.querySelector('canvas');
            isResizing = true;
            lastDownY = e.clientY || e.touches[0].clientY;
            e.preventDefault(); // Prevent default touch behavior
        }

        document.addEventListener('mousemove', resize);
        document.addEventListener('touchmove', resize);

        function resize(e) {
            if (!isResizing) return;

            var clientY = e.clientY || e.touches[0].clientY;
            var deltaY = clientY - lastDownY;
            var newHeightTop = topDiv_updated.offsetHeight + deltaY;
            if (newHeightTop > 500 || newHeightTop < 210) {
                return;
            }
            var newHeightBottom = bottomDiv.offsetHeight - deltaY;
            topDiv_updated.style.height = newHeightTop + 'px';
            bottomDiv.style.height = newHeightBottom + 'px';

            lastDownY = clientY;
            e.preventDefault(); // Prevent default touch behavior
        }

        document.addEventListener('mouseup', stopResize);
        document.addEventListener('touchend', stopResize);

        function stopResize() {
            isResizing = false;
        }

        const rightPanel = document.getElementById("right-side");
        function rightPanelLock() {
            rightPanel.style.overflow = 'hidden';
        }
        function rightPanelUnlock() {
            rightPanel.style.overflow = 'auto';
        }
        // <-- Mobile screen resize feature End Here -->

        // function to control selected color text
        // document.addEventListener('customizer.recipe-changed', function() {

        //     // Get the element with the class 'customizer-tab-summary-item-name'
        //     let summaryItem = document.querySelector('.customizer-tab-summary-item-name');

        //     // Get the text content of the element
        //     let colorName = summaryItem.textContent.trim();
        //     colorName = colorName.toUpperCase();

        //     let prefix = '<strong>Color Options</strong> (Selected: ';

        //     // Append ')' to the color name
        //     let suffix = ')';

        //     // Wrap the color name in a span
        //     colorName = '<span class="color-name">' + colorName + '</span>';

        //     // Concatenate all parts
        //     let updatedContent = prefix + colorName + suffix;


        //     // Set the updated text content back to the element
        //     summaryItem.innerHTML = updatedContent;
        //     summaryItem.setAttribute('aria-live', 'polite');
        //     summaryItem.setAttribute('role', 'status');
        //     summaryItem.setAttribute('aria-atomic', 'true');



        // });

        // This code manages the tab configuration for the third and fourth tabs by dynamically adding classes based on which tab is clicked.



        // fit guide teleporting content

        var fittingOpenButton = document.getElementById('customizer-element-fitting-need-help-action');
        if (fittingOpenButton) {
            fittingOpenButton.setAttribute('tabindex', '0');
        }
        var fittingHideButton = document.getElementById('customizer-fit-hide-icon');
        var teleportDiv = document.getElementById('fit-guide');

        var sizeOpenButton = document.getElementById('customizer-element-size-need-help-action');
        var sizeHideButton = document.getElementById('customizer-size-hide-icon');
        var teleportDivSize = document.getElementById('teleport-size');
        var buttonQr = document.getElementById('customizer-element-size_find_your_size');
        if (buttonQr) {
            sizeOpenButton.parentNode.insertBefore(buttonQr, sizeOpenButton.nextSibling);
            buttonQr.style.display = 'flex';
        }

        // var flexOpenButton = document.getElementById('flex-guide');
        // var flexHideButton = document.getElementById('customizer-flex-hide-icon');
        // var teleportDivFlex = document.getElementById('teleport-flex');


        // var findOpenButton = document.getElementById('pattern-guide');
        // var findHideButton = document.getElementById('customizer-find-hide-icon');
        // var teleportDivFind = document.getElementById('teleport-pattern-guide');


        // var compareOpenButton = document.getElementById('pattern-compare');
        // var compareHideButton = document.getElementById('customizer-compare-hide-icon');
        // var teleportDivCompare = document.getElementById('teleport-pattern-compare');





        function teleporting() {
            // Move the #teleport div after the reference element
            if (fittingOpenButton) {
                fittingOpenButton.parentNode.insertBefore(teleportDiv, fittingOpenButton.nextSibling);
            }
            // Show the #teleport div after moving it
            setTimeout(() => {
                if (window.innerWidth < 750) {
                    teleportDiv.style.transform = 'translateY(0)';
                } else {
                    teleportDiv.style.transform = 'translateX(0)';
                }
            }, 10); // Adjust the delay time (in milliseconds) as needed

            teleportDiv.style.display = 'block';
            setTimeout(() => {
                teleportDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 300);
            // Centering the scroll position

            // Centering the horizontal scroll position
            var containers = document.querySelectorAll('.fit-slider');
            containers.forEach(function (container) {
                var content = container.querySelector('.slides');
                container.scrollLeft = (content.scrollWidth - container.clientWidth) / 2;
            });

            var scrollAmount = 150; // Amount to scroll by
            var currentPosition = 0;

            $('#nextBtn').click(function () {
                currentPosition += scrollAmount;
                $('.first-fit-slider').animate({ scrollLeft: currentPosition }, "slow");
            });

            $('#prevBtn').click(function () {
                currentPosition -= scrollAmount;
                $('.first-fit-slider').animate({ scrollLeft: currentPosition }, "slow");
            });

            $('#nextBtn2').click(function () {
                currentPosition += scrollAmount;
                $('.second-fit-slider').animate({ scrollLeft: currentPosition }, "slow");
            });

            $('#prevBtn2').click(function () {
                currentPosition -= scrollAmount;
                $('.second-fit-slider').animate({ scrollLeft: currentPosition }, "slow");
            });
        }

        if (fittingOpenButton) {
            fittingOpenButton.addEventListener('click', function () {
                teleporting();
                rightPanelLock();
            });
        }
        if (fittingHideButton) {
            fittingHideButton.addEventListener('click', function () {
                setTimeout(() => {
                    if (window.innerWidth < 750) {
                        teleportDiv.style.transform = 'translateY(100%)';
                    } else {
                        teleportDiv.style.transform = 'translateX(100%)';
                    }
                }, 10); // Adjust the delay time (in milliseconds) as needed
                setTimeout(() => {
                    teleportDiv.style.display = 'none';
                    rightPanelUnlock();
                }, 300); // Adjust the delay time (in milliseconds) as needed

            });
        }



        function teleportingSizeGuide() {
            // Move the #teleport div after the reference element
            if (sizeOpenButton) {
                sizeOpenButton.parentNode.insertBefore(teleportDivSize, sizeOpenButton.nextSibling);
            }
            teleportDivSize.style.display = 'block';

            setTimeout(() => {
                if (window.innerWidth < 750) {
                    teleportDivSize.style.transform = 'translateY(0)';
                } else {
                    teleportDivSize.style.transform = 'translateX(0)';
                }
            }, 10); // Adjust the delay time (in milliseconds) as needed
            setTimeout(() => {
                teleportDivSize.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 300);
        }
        if (sizeOpenButton) {
            sizeOpenButton.addEventListener('click', function () {
                teleportingSizeGuide();
                rightPanelLock();
            });
        }
        sizeHideButton.addEventListener('click', function () {

            setTimeout(() => {
                if (window.innerWidth < 750) {
                    teleportDivSize.style.transform = 'translateY(100%)';
                } else {
                    teleportDivSize.style.transform = 'translateX(100%)';
                }
            }, 10); // Adjust the delay time (in milliseconds) as needed
            setTimeout(() => {
                teleportDivSize.style.display = 'none';
                rightPanelUnlock();
            }, 300); // Adjust the delay time (in milliseconds) as needed

        });


        // function teleportingFlexGuide() {
        //     // Move the #teleport div after the reference element
        //     flexOpenButton.parentNode.insertBefore(teleportDivFlex, flexOpenButton.nextSibling);
        //     // Show the #teleport div after moving it
        //     teleportDivFlex.style.display = 'block';
        //     setTimeout(() => {
        //          if (window.innerWidth < 750) {
        //           teleportDivFlex.style.transform = 'translateY(0)';
        //         } else {
        //            teleportDivFlex.style.transform = 'translateX(0';
        //         }
        //     }, 10); // Adjust the delay time (in milliseconds) as needed
        // }

        // flexOpenButton.addEventListener('click', teleportingFlexGuide);
        // flexHideButton.addEventListener('click', function() {

        //      setTimeout(() => {
        //          if (window.innerWidth < 750) {
        //           teleportDivFlex.style.transform = 'translateY(100%)';
        //         } else {
        //            teleportDivFlex.style.transform = 'translateX(100%)';
        //         }
        //     }, 10); // Adjust the delay time (in milliseconds) as needed
        //        setTimeout(() => {
        //             teleportDivFlex.style.display = 'none';
        //     }, 300); // Adjust the delay time (in milliseconds) as needed
        // });


        // function teleportingFindPattern() {
        //     // Move the #teleport div after the reference element
        //     findOpenButton.parentNode.insertBefore(teleportDivFind, findOpenButton.nextSibling);
        //     // Show the #teleport div after moving it
        //     teleportDivFind.style.display = 'block';
        //     setTimeout(() => {
        //         if (window.innerWidth < 750) {
        //           teleportDivFind.style.transform = 'translateY(0)';
        //         } else {
        //            teleportDivFind.style.transform = 'translateX(0)';
        //         }
        //     }, 10); // Adjust the delay time (in milliseconds) as needed
        // }

        // findOpenButton.addEventListener('click', teleportingFindPattern);
        // findHideButton.addEventListener('click', function() {

        //     setTimeout(() => {
        //         if (window.innerWidth < 750) {
        //           teleportDivFind.style.transform = 'translateY(100%)';
        //         } else {
        //            teleportDivFind.style.transform = 'translateX(100%)';
        //         }
        //     }, 10); // Adjust the delay time (in milliseconds) as needed
        //        setTimeout(() => {
        //             teleportDivFind.style.display = 'none';
        //     }, 300); // Adjust the delay time (in milliseconds) as needed
        // });



        // function teleportingComparePattern() {
        //     // Move the #teleport div after the reference element
        //     compareOpenButton.parentNode.insertBefore(teleportDivCompare, compareOpenButton.nextSibling);
        //     // Show the #teleport div after moving it
        //     teleportDivCompare.style.display = 'block';
        //    setTimeout(() => {
        //         if (window.innerWidth < 750) {
        //           teleportDivCompare.style.transform = 'translateY(0)';
        //         } else {
        //            teleportDivCompare.style.transform = 'translateX(0)';
        //         }
        //     }, 10); // Adjust the delay time (in milliseconds) as needed
        // }

        // compareOpenButton.addEventListener('click', teleportingComparePattern);
        // compareHideButton.addEventListener('click', function() {
        //     setTimeout(() => {
        //         if (window.innerWidth < 750) {
        //           teleportDivCompare.style.transform = 'translateY(100%)';
        //         } else {
        //            teleportDivCompare.style.transform = 'translateX(100%)';
        //         }
        //     }, 10); // Adjust the delay time (in milliseconds) as needed

        //       setTimeout(() => {
        //             teleportDivCompare.style.display = 'none';
        //     }, 300); // Adjust the delay time (in milliseconds) as needed
        // });





        // Print button & funtion call
        // const printButton = document.getElementById("printButton");
        const intButton = document.getElementById("intractive-buttons");




        // To teleport above the target element
        var targetElement = document.querySelector("#optional_id .customizer-element-title");
        var elementToMove = intButton;
        if (targetElement) {
            targetElement.parentNode.insertBefore(elementToMove, targetElement);
            intButton.style.display = 'flex';

            // To teleport inside the target element
            targetElement.appendChild(intButton);
        }


        // const initPrintSummaryHandler = () => {
        //     printButton.addEventListener('click', async () => {
        //         await customizer.printSummary();
        //     });
        // }
        // initPrintSummaryHandler();



        // const teleportProCustom = document.getElementById('pro-custom');
        // const targetTotalPriceDiv = document.querySelector("#optional_id");
        // function teleportingProCustom() {
        //     // Move the #teleport div after the reference element
        //     targetTotalPriceDiv.parentNode.insertBefore(teleportProCustom, targetTotalPriceDiv.nextSibling);
        //     // Show the #teleport div after moving it
        //     teleportProCustom.style.display = 'block';
        // }
        // teleportingProCustom();


        // const deliveryDate = document.getElementById('vu-date');
        // const targetBodyReview = document.getElementById("optional_id");
        // function teleportingDeliveryDate() {
        //     // Move the #teleport div after the reference element
        //     targetBodyReview.parentNode.insertBefore(deliveryDate, targetBodyReview);
        //     // Show the #teleport div after moving it
        //     deliveryDate.style.display = 'block';
        // }
        // teleportingDeliveryDate();


        // const bottomNote = document.getElementById('review-tab-bottom-note');
        // function teleportingBottomNote() {
        //     // Move the #teleport div after the reference element
        //     targetBodyReview.parentNode.insertBefore(bottomNote, targetBodyReview.nextSibling);
        //     // Show the #teleport div after moving it
        //     bottomNote.style.display = 'block';
        // }
        // teleportingBottomNote();

        // let summaryItems = document.querySelectorAll('.customizer-element-summary-group-title');

        // summaryItems.forEach(item => {
        //   setTimeout(() => {
        //     item.textContent = item.textContent.toLowerCase();
        //   }, 3000); // 3000 milliseconds = 3 seconds
        // });



    });




    //for splash loading screen

    // function openPopUpModal() {
    //     // Check if the event has already been triggered
    //     // if (!performance.getEntriesByType("navigation")[0].type === "navigate") {
    //     // // Set the flag to true if the page is not being loaded for the first time
    //     // sceneRenderedFlag = true;
    //     // }
    //     if (sceneRenderedFlag) {
    //         openModal();
    //     } else {
    //         openLoadingModal();
    //         // Adding an event listener for 'customizer.scene-rendered' event
    //         document.addEventListener('customizer.scene-rendered', function() {
    //             sceneRenderedFlag = true;
    //             openModal();
    //         }, { once: true }); // { once: true } ensures the event listener only runs once
    //     }
    // }


    function openPopUpModal() {
        // Check if the event has already been triggered
        // if (!performance.getEntriesByType("navigation")[0].type === "navigate") {
        // // Set the flag to true if the page is not being loaded for the first time
        // sceneRenderedFlag = true;
        // }

        if (sceneRenderedFlag) {
            openModal();
            callTrapOnSelectedTab();
        } else {
            openLoadingModal();
            // Adding an event listener for 'customizer.scene-rendered' event
            document.addEventListener('customizer.scene-rendered', function () {
                sceneRenderedFlag = true;
                openModal();
            }, { once: true }); // { once: true } ensures the event listener only runs once

            // Check if event listener hasn't been triggered in 10 seconds
            setTimeout(function () {
                if (!sceneRenderedFlag) {
                    ErrorModal();
                }
            }, 40000); // 20 seconds in milliseconds
        }
    }

});
function handleRecipeUpdatesComplete(event) {
    const recipe = event?.detail?.recipe;
    const elementMapping = {
        'fit': 'fitting_info',
        'tongue_model': 'tongue_info',
        'color': 'color_info',
        // 'blade_fit': 'blade_fit_info',
        // 'holder_fit': 'holder_fit_info'
    };

    Object.entries(recipe).forEach(([elementCode, elementData]) => {
        const targetElementKey = elementMapping[elementCode];

        if (targetElementKey) {
            const targetElement = customizer.elements[targetElementKey];

            if (targetElement) {
                targetElement.show();

                targetElement.hideAllOptions();

                targetElement.toggleOptionVisibility(elementData.value.code, true);
            }
        }
    });

    updateNextButtonState();
}




    
     // Function to handle Add to Cart button state
    const handleAddToCartState = () => {
    const addToCartButton = document.getElementById('customizer-add-to-cart-button');
    const errorMessage = document.getElementById('customizer-error-message');
    
    if (addToCartButton) {
      // Set initial state
      const buttonText = addToCartButton.querySelector('.add-to-cart-text');
      
      // Add CSS class for styling instead of inline styles
      if (errorMessage) {
        errorMessage.classList.add('error-toast');
      }
      
      // Remove any existing event listeners
      const existingListener = function(event) {
        console.log('Add to cart failed:', event.detail);
        showError();
      };
      document.removeEventListener('customizer.add-to-cart-fail', existingListener);
      
      // Add click handler
      addToCartButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Enter loading state
        addToCartButton.setAttribute('disabled', 'disabled');
        addToCartButton.classList.add('loading');
        
        // Add the event listener for add-to-cart-fail
        document.addEventListener('customizer.add-to-cart-fail', function(event) {
          console.log('Add to cart failed:', event.detail);
          showError();
        }, { once: true }); // Use once: true to ensure the listener is removed after it's fired
      });
      
      function showError() {
        // Reset button state
        addToCartButton.removeAttribute('disabled');
        addToCartButton.classList.remove('loading');
        
        // Show error message with animation
        errorMessage.classList.remove('hidden');
        errorMessage.style.opacity = '0';
        
        // Trigger animation
        setTimeout(() => {
          errorMessage.style.opacity = '1';
        }, 10);
        
        // Hide error message after 3 seconds with fade out
        setTimeout(() => {
          errorMessage.style.opacity = '0';
          
          errorMessage.classList.add('hidden');
          
        }, 3000);
      }
    }
   };
   
     